import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
export default function () {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "yyyy-MM-dd hh:mm:ss";
  var o = {
    "M+": value.getMonth() + 1,
    //month  
    "d+": value.getDate(),
    //day  
    "h+": value.getHours(),
    //hour  
    "m+": value.getMinutes(),
    //minute  
    "s+": value.getSeconds(),
    //second  
    "q+": Math.floor((value.getMonth() + 3) / 3),
    //quarter  
    "S": value.getMilliseconds() //millisecond  
  };
  if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (value.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
  }
  return format;
}